import Navbar from '@/components/feature/Navbar';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import StatsSection from './components/StatsSection';
import SafetySection from './components/SafetySection';
import BlogSection from './components/BlogSection';
import CTASection from './components/CTASection';
import FAQSection from './components/FAQSection';
import TestimonialSection from './components/TestimonialSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebSite",
          "name": "Kakobuy Spreadsheet",
          "url": "https://kakobuyspreadsheet.bar",
          "description": "The largest Kakobuy Spreadsheet resource hub. Find trusted products, verified sellers, and updated buying guides.",
          "potentialAction": {
            "@type": "SearchAction",
            "target": "https://kakobuyspreadsheet.bar/search?q={search_term_string}",
            "query-input": "required name=search_term_string"
          }
        })}
      </script>
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": [
            {
              "@type": "Question",
              "name": "What is Kakobuy Spreadsheet?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Kakobuy Spreadsheet is a comprehensive resource hub that aggregates thousands of verified products, trusted sellers, and detailed buying guides from the KaSpreadsheet platform."
              }
            },
            {
              "@type": "Question",
              "name": "How often is the Kakobuy Spreadsheet updated?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "The Kakobuy Spreadsheet is updated weekly with new product listings, seller verifications, and fresh buying guides."
              }
            },
            {
              "@type": "Question",
              "name": "Is the Kakobuy Spreadsheet safe to use?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes, Kakobuy Spreadsheet prioritizes safety. We only list products from verified sellers with proven track records."
              }
            },
            {
              "@type": "Question",
              "name": "How do I use the Kakobuy Spreadsheet to find products?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Browse our 14 categories using the dropdown menu or category grid on this page. Each category links directly to verified product collections on KaSpreadsheet."
              }
            },
            {
              "@type": "Question",
              "name": "Which product categories are available?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Kakobuy Spreadsheet covers 14 categories: Shoes, Hoodies/Sweaters, T-Shirts, Jackets, Pants/Shorts, Headwear, Sets, Underwear, Jersey, Accessories, Bags, Belts, Perfumes, and OtherStuff."
              }
            }
          ]
        })}
      </script>

      <main>
        <Navbar />
        <HeroSection />
        <CategoryGrid />
        <StatsSection />
        <SafetySection />
        <BlogSection />
        <CTASection />
        <TestimonialSection />
        <div id="faq">
          <FAQSection />
        </div>
      </main>
      <Footer />
    </>
  );
}